import { Network } from "@capacitor/network";

import { isNativeApp } from "./native";

// Android's WebView never updates navigator.onLine or fires online/offline
// events on its own, so in the app the connection state comes from the OS.

export async function isOnline(): Promise<boolean> {
  if (!isNativeApp) return navigator.onLine;
  try {
    return (await Network.getStatus()).connected;
  } catch {
    return navigator.onLine;
  }
}

// Runs `callback` each time the device regains a connection. Returns a cleanup function.
export function onReconnect(callback: () => void): () => void {
  if (!isNativeApp) {
    window.addEventListener("online", callback);
    return () => window.removeEventListener("online", callback);
  }
  const handle = Network.addListener("networkStatusChange", (status) => {
    if (status.connected) callback();
  });
  return () => {
    handle.then((h) => h.remove()).catch(() => {});
  };
}
